import React, { ReactNode, useMemo } from 'react';

import ButtonComponent from '@r1-frontend/ui-react/components/buttons/button';
import { Separator } from '@r1-frontend/ui-react/components/Separator';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { BlindMenu } from '../index';

import * as ST from './styled';

export enum EElemType {
    button = 'button',
    divider = 'divider',
}

interface IBaseElemData {
    id: string,
}

export interface IButtonElemData extends IBaseElemData {
    type: EElemType.button,
    text: string,
    link?: string,
    target?: string,
    onClick?: () => void,
    iconRight?: ReactNode,
}

export interface IDividerElemData extends IBaseElemData {
    type: EElemType.divider,
}

export type TElemData =  IButtonElemData | IDividerElemData

interface IProps {
    isMobileView: boolean,
    elements: TElemData[],
    btnText?: string,
    Button?: JSX.Element,
    blindMenuRef?: React.RefObject<HTMLDivElement>,
    onElementClick?: (id: string) => void,
    displayDropDown?: boolean,
    [key: string]: unknown,
}

export const BlindMenuWithBtn = ({
    btnText = 'Меню',
    Button,
    isMobileView,
    elements,
    displayDropDown,
    blindMenuRef,
    onElementClick,
    ...rest
}: IProps): JSX.Element => {

    const elementClickHandler = (el: TElemData) => {
        if (el.type !== EElemType.button) {
            return;
        }
        if (el.onClick) {
            el.onClick();
            return;
        }
        if (onElementClick) {
            onElementClick(el.id);
        }
    };

    const activeComponent = useMemo(
        () => Button || <DefaultButton btnText={btnText}/>,
        [Button, btnText],
    );

    const renderElement = (element: TElemData) => {
        if (element.type === EElemType.button) {
            return (
                <ST.Anchor key={element.id} href={element.link} target={element.target}>
                    <ST.Button
                        isMobileView={isMobileView}
                        bType={isMobileView ? 'secondary' : 'ghost'}
                        size='small'
                        onClick={() => elementClickHandler(element)}
                        Icon={element.iconRight}
                        iconSide='right'
                        justifyContent='space-between'
                    >
                        {element.text}
                    </ST.Button>
                </ST.Anchor>
            );
        }
        if (element.type === EElemType.divider) {
            return <Separator key={element.id} $color={COLORS.ButtonSecondary} />;
        }
    };

    return (
        <BlindMenu
            activeComponent={activeComponent}
            displayDropDown={displayDropDown}
            isMobileView={isMobileView}
            blindMenuRef={blindMenuRef}
            {...rest}
        >
            {elements.map(renderElement)}
        </BlindMenu>
    );
};

const DefaultButton = ({ btnText }: Pick<IProps, 'btnText'>) => <ButtonComponent size='small' bType='secondary'>{btnText}</ButtonComponent>;
